import React from 'react';

import {
  Box as BoxBase,
  MenuItem as MenuItemBase,
  styled,
} from '@mui/material';

import { useHandlers as useBinderHandlers } from '../../../../inbox/ClusterBinderOptions';

import { withShowable } from '../../../_global/lib/withShowable';
import PolicyHolderQuotePolicySummary from '../../../quotes-policies/drawers/PolicyHolderQuotePolicySummary';
import {
  MenuTriggerButton,
  SimpleMenu,
} from '../../../../components/Menus/SimpleMenu';

import {
  ACTIVE_STATUS,
  BOUND_STATUS,
  IN_FORCE_STATUS,
  ISSUED_STATUS,
  RENEWED_STATUS,
} from '../../../_statics/policy.statics';
import policiesService from '../../policies.service';
import { ProductTypes, isLedgerStyleProduct } from '../../../../types';
import { useAgencyPoliciesOptionHandlers as usePolicyCommonHandlers } from '../../../agency/logic/policies/agency-policies.logic';

const MenuItem = withShowable(MenuItemBase);

const FlexBox = withShowable(
  styled(BoxBase)(() => ({
    display: 'flex',
  }))
);

export default function PolicyHolderPolicySummary({
  policy,
  closeDrawer,
}: any) {
  const isActive = React.useMemo(
    () =>
      [
        ACTIVE_STATUS,
        IN_FORCE_STATUS,
        ISSUED_STATUS,
        BOUND_STATUS,
        RENEWED_STATUS,
      ].includes(policy.status),
    [policy.status]
  );

  return (
    <PolicyHolderQuotePolicySummary {...policy}>
      <FlexBox
        alignItems="center"
        width="15%"
        height="inherit"
        justifyContent="flex-end"
        pr={1}
        show={isActive}
      >
        <PolicyHolderPolicySummaryDownloadButtons
          policy={policy}
          closeDrawer={closeDrawer}
        />
      </FlexBox>
    </PolicyHolderQuotePolicySummary>
  );
}

export const PolicyHolderPolicySummaryDownloadButtons = ({
  policy,
  closeDrawer = () => null,
}: any) => {
  const {
    handleDownloadDocs,
    downloadEmailCertificate,
    handleDownloadApplication,
    handleDownloadInvoice,
    handleDownloadReceipt,
    handleDownloadPlan,
  } = usePolicyCommonHandlers(policy);

  const { handleDownloadBinder } = useBinderHandlers(policy);

  function handleDownloadEmailCertificate() {
    closeDrawer();
    downloadEmailCertificate();
  }

  const isInvoiceAvailable = policy.isDocumentAvailable;

  return (
    <SimpleMenu
      id="policyholder-policy-summary-options"
      anchor={<MenuTriggerButton />}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <MenuItem show={!policy.isPrimePlus} onClick={handleDownloadApplication}>
        Download Application
      </MenuItem>

      <MenuItem
        show={policiesService.isBinder(policy)}
        onClick={handleDownloadBinder}
      >
        Download Binder
      </MenuItem>

      <MenuItem show={policy.isPremiumFinanced} onClick={handleDownloadPlan}>
        Download Financing Agreement
      </MenuItem>

      <MenuItem
        show={!policy.agencyBilled && isInvoiceAvailable}
        onClick={handleDownloadInvoice}
      >
        Download Invoice
      </MenuItem>

      <MenuItem
        show={
          !policiesService.isBinder(policy) && policy.isCertificateAvailable
        }
        onClick={handleDownloadEmailCertificate}
      >
        Download Policy Certificate
      </MenuItem>

      <MenuItem
        show={!policiesService.isBinder(policy) && policy.isDocumentAvailable}
        onClick={handleDownloadDocs}
      >
        Download Policy Documents
      </MenuItem>

      <MenuItem
        show={policy.isPaid && !isLedgerStyleProduct(policy.product)}
        onClick={handleDownloadReceipt}
      >
        Download Receipt
      </MenuItem>
    </SimpleMenu>
  );
};
